/** "2026-10-31" in the buyer's own timezone, so the calendar never starts yesterday. */
export function localIsoDate(d = new Date()) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** "2026-10-31" → "Saturday, October 31"; a real date so the agent never guesses which Saturday. */
export function bookingDateLabel(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || ''));
  if (!m) return '';
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return d.toLocaleDateString('en-CA', { weekday: 'long', month: 'long', day: 'numeric' });
}

/** "Saturday, October 31, morning (after 10)". */
export function otherTimeText(iso, partOfDay, note) {
  const day = bookingDateLabel(iso);
  if (!day) return '';
  const extra = String(note || '').trim();
  return [day, partOfDay ? partOfDay.toLowerCase() : null].filter(Boolean).join(', ') + (extra ? ` (${extra})` : '');
}
